<script setup>
import { ref, watch } from 'vue';
import Draggable from 'vuedraggable';
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';
import InputNext from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  preChatFields: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update', 'dragEnd']);

const preChatFieldOptions = ref(props.preChatFields);

const isFieldEditable = item => {
  return !item.enabled;
};

const handlePreChatFieldOptions = (event, type, item) => {
  emit('update', event, type, item);
};

const onDragEnd = () => {
  emit('dragEnd', preChatFieldOptions.value);
};

watch(
  () => props.preChatFields,
  newFields => {
    preChatFieldOptions.value = newFields;
  }
);
</script>

<template>
  <Draggable
    v-model="preChatFieldOptions"
    tag="tbody"
    item-key="key"
    handle=".handle"
    @end="onDragEnd"
  >
    <template #item="{ element: item }">
      <tr>
        <td
          class="py-4 ltr:pl-4 ltr:pr-3 rtl:pl-3 rtl:pr-4 text-body-main handle"
        >
          <Icon
            icon="i-woot-drag-indicator"
            class="size-4 text-n-slate-11 mt-1 cursor-move"
          />
        </td>
        <td class="py-4 ltr:pr-3 rtl:pl-3 text-body-main">
          <ToggleSwitch
            :model-value="item['enabled']"
            @change="handlePreChatFieldOptions($event, 'enabled', item)"
          />
        </td>
        <td
          class="py-4 ltr:pr-3 rtl:pl-3 text-body-main"
          :class="{ 'text-n-slate-11': !item['enabled'] }"
        >
          {{ item.name }}
        </td>
        <td class="py-4 ltr:pr-3 rtl:pl-3 text-body-main">
          <InputNext
            v-model.trim="item.description"
            type="text"
            :disabled="isFieldEditable(item)"
          />
        </td>
        <td
          class="py-4 ltr:pr-4 rtl:pl-4 text-body-main"
          :class="{ 'text-n-slate-11': !item['enabled'] }"
        >
          {{ item.type }}
          {{
            item.type == 'list' && item.values && item.values.length > 0
              ? `(${item.values})`
              : ''
          }}
          {{
            item.type == 'text' && item.regex_pattern
              ? `(${item.regex_pattern})`
              : ''
          }}
        </td>
      </tr>
    </template>
  </Draggable>
</template>
